export const composeWrappers = function (wrappers, state) {
  let wrappedFetch = fetch;
  // eslint-disable-next-line no-restricted-syntax
  for (const wrapper of wrappers) {
    wrappedFetch = wrapper(state, wrappedFetch);
  }

  return wrappedFetch;
};
